import classNames from 'classnames';

import { NodeModel } from '@minoru/react-dnd-treeview';

import { SpaceNodeData } from '../hooks/use-space-tree-data';

interface SpaceTreePlaceholderArrowProps {
  invert?: boolean;
}

function SpaceTreePlaceholderArrow({ invert }: SpaceTreePlaceholderArrowProps) {
  return (
    <div className={classNames(
      'absolute z-0 top-[1.5px] bottom-0 border-x-[6px] border-x-transparent border-b-[12px] border-b-cyan-400 translate-y-[-50%]',
      invert ? '-rotate-90 right-0' : 'rotate-90 left-0 '
    )} />
  );
}

interface SpaceTreePlaceholderProps {
  node: NodeModel<SpaceNodeData>;
  depth: number;
}

export function SpaceTreePlaceholder({ node, depth }: SpaceTreePlaceholderProps) {
  return (
    <div
      className={classNames(
        'bg-cyan-400 h-1 absolute right-0 top-0 translate-y-[-50%]',
        ``
      )}
      style={{ left: 16 * depth }}
    >
      <SpaceTreePlaceholderArrow />
      <SpaceTreePlaceholderArrow invert />
    </div>
  );
}
